import "./GetAnEstimate.module.css";
import VilHeader from "@/reusable_sections/Header";
import LetsTalkLandscaping from "./sections/LetsTalkLandscaping";
import OurServiceArea from "./sections/OurServiceArea";
import SiteFooter from "@/reusable_sections/Footer";
export default function GetAnEstimatePage() {
  return <div>
      <VilHeader />
      <LetsTalkLandscaping />
      <OurServiceArea />
      <SiteFooter />
    </div>;
}